import { Component, OnInit, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { ChangeLog } from '../models';
import { ChangelogService } from '../changelog.service';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-changelog-hoverover',
  templateUrl: './changelog-hoverover.component.html',
  styleUrls: ['./changelog-hoverover.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChangeLogHoverOverComponent implements OnInit {
  @Input() displayConfigurationId: number;
  @Input() event: Event;
  changelog: ChangeLog = {};
  loading = false;
  @ViewChild('hoverOverDataContainer') hoverOverDataContainer: OverlayPanel;
  @ViewChild('hoverOverProgressSpinner') hoverOverProgressSpinner: OverlayPanel;
  constructor(private changeLogSrv: ChangelogService) { }

  ngOnInit() {
    this.loadData();
  }

  // Logic for load data, show HoverOver pop up and its loader
  loadData(): void {
    this.hoverOverProgressSpinner.hide();
    this.hoverOverProgressSpinner.show(this.event);
    this.loading = true;
    this.changeLogSrv.findByPropertyId(this.displayConfigurationId)
      .subscribe((response: any) => {
        this.loading = false;
        this.hoverOverProgressSpinner.hide();
        this.changelog = response.data[0] as ChangeLog;
        this.hoverOverDataContainer.show(this.event);
      });
  }

  // hide changelog popup and its loader
  hideChangeLogPopup(): void {
    this.hoverOverProgressSpinner.hide();
    this.hoverOverDataContainer.hide();
    this.loading = false;
  }
}
